<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const { t } = useI18n();

const data = computed(() => props.data);

const unitOptions = [
  {
    value: 'seconds',
    label: t('FLOW_BUILDER.NODE_EDITOR.DELAY.UNITS.SECONDS'),
  },
  {
    value: 'minutes',
    label: t('FLOW_BUILDER.NODE_EDITOR.DELAY.UNITS.MINUTES'),
  },
  { value: 'hours', label: t('FLOW_BUILDER.NODE_EDITOR.DELAY.UNITS.HOURS') },
  { value: 'days', label: t('FLOW_BUILDER.NODE_EDITOR.DELAY.UNITS.DAYS') },
];

const onValueChange = event => {
  const value = parseInt(event.target.value, 10);
  emit('update', { delay_value: Math.max(1, value || 1) });
};

const onUnitChange = event => {
  emit('update', { delay_unit: event.target.value });
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-1.5">
      <label class="text-[11px] font-medium text-n-slate-11">
        {{ t('FLOW_BUILDER.NODE_EDITOR.DELAY.VALUE') }}
      </label>
      <input
        :value="data.delay_value || 1"
        type="number"
        min="1"
        class="w-full px-3 py-2 text-sm border border-n-weak dark:border-n-strong rounded-lg bg-transparent text-n-slate-12 outline-none focus:border-n-blue-5"
        @input="onValueChange"
      />
    </div>
    <div class="flex flex-col gap-1.5">
      <label class="text-[11px] font-medium text-n-slate-11">
        {{ t('FLOW_BUILDER.NODE_EDITOR.DELAY.UNIT') }}
      </label>
      <select
        :value="data.delay_unit || 'seconds'"
        class="w-full px-3 py-2 text-sm border border-n-weak dark:border-n-strong rounded-lg bg-transparent text-n-slate-12 outline-none focus:border-n-blue-5"
        @change="onUnitChange"
      >
        <option v-for="opt in unitOptions" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>
  </div>
</template>
